import { appData } from '@/mocks/homeData';

export default function AppSection() {
  const d = appData;

  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/15 border border-accent-500/25 mb-4">
          <i className="ri-smartphone-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-xs font-medium">{d.badge}</span>
        </div>

        <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50 mb-3">
          {d.title}
        </h2>
        <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto mb-8">
          {d.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50 text-background-950 font-bold text-sm transition-all duration-200 cursor-pointer hover:bg-background-100"
          >
            <i className="ri-apple-fill text-lg"></i>
            App Store 下载
          </a>
          <a
            href="#"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 font-medium text-sm transition-all duration-200 cursor-pointer hover:bg-background-50/20"
          >
            <i className="ri-google-play-fill text-lg"></i>
            Google Play 下载
          </a>
          <a
            href="#"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-background-50/10 border border-background-50/20 text-background-50 font-medium text-sm transition-all duration-200 cursor-pointer hover:bg-background-50/20"
          >
            <i className="ri-qr-code-line text-lg"></i>
            扫码下载 APK
          </a>
        </div>
      </div>
    </section>
  );
}